<div class="div_token-splash-screen">
</div>